"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormState = void 0;
const react_hook_form_1 = require("react-hook-form");
const FormState = () => {
    const { formState: { errors, isDirty, isValid }, } = (0, react_hook_form_1.useFormContext)();
    console.info({ isDirty, isValid, errors });
    return null;
};
exports.FormState = FormState;
//# sourceMappingURL=state.js.map